import { PROGRAM_ADHERENCE } from "../actions";

export const programAdherence = (state = {}, action) => {
  if (action.type == PROGRAM_ADHERENCE) return action.payload;
  return state;
};
